var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.375C11.3284 7.375 12 6.70343 12 5.875C12 5.04657 11.3284 4.375 10.5 4.375C9.67157 4.375 9 5.04657 9 5.875C9 6.70343 9.67157 7.375 10.5 7.375Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 5.875C15.75 11.125 10.5 14.125 10.5 14.125C10.5 14.125 5.25 11.125 5.25 5.875C5.25 4.48261 5.80312 3.14726 6.78769 2.16269C7.77226 1.17812 9.10761 0.625 10.5 0.625C11.8924 0.625 13.2277 1.17812 14.2123 2.16269C15.1969 3.14726 15.75 4.48261 15.75 5.875Z",
    stroke: "#888888",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 12.9199C19.0987 13.6024 20.25 14.5624 20.25 15.6255C20.25 17.6965 15.885 19.3755 10.5 19.3755C5.115 19.3755 0.75 17.6965 0.75 15.6255C0.75 14.5624 1.90125 13.6024 3.75 12.9199",
    stroke: "#888888",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationlogo);
export default __webpack_public_path__ + "static/media/locationlogo.383ae341b2952842bde6efdab3a909e0.svg";
export { ForwardRef as ReactComponent };